import { call, put, select, takeLatest } from 'redux-saga/effects'
import { throwPcrException } from '../../pcr/store/pcr.actions'
import { getServiceIdSelector } from '../../user/selectors'
import { OptionsService } from '../services/options.service'
import { setSpecialReportCategories } from '../store/options.actions'
import { ClientDataConstants } from '../../clientData/store/clientData.constants'
import { IOptionsResponse } from '../../../common/common.types'

export function* getSpecialReportCategories() {
  const serviceId: string = yield select(getServiceIdSelector)
  const optionsService = new OptionsService(serviceId)

  try {
    const response: IOptionsResponse = yield call([optionsService, optionsService.getSpecialReportCategories])
    const { entity } = response
    if (entity) {
      yield put(setSpecialReportCategories(entity))
    }
  } catch (e) {
    yield put(throwPcrException(`getSpecialReportCategories() error: ${e}`))
  }
}

export function* getSpecialReportCategoriesSaga() {
  yield takeLatest([ClientDataConstants.ON_CLIENT_DATA_IMPORT_SUCCESS], getSpecialReportCategories)
}
